"use client";

import ErrorScreen from "@/components/common/ErrorScreen";

export default function RootSegmentError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  return (
    <ErrorScreen
      title="Halaman ini gagal dimuat"
      description="Ada kendala saat menyiapkan halaman. Datamu aman — kalau kamu sedang menyelesaikan pembayaran, pesanannya tetap tersimpan dan bisa dilanjutkan dari Riwayat Transaksi."
      digest={error.digest}
      onRetry={unstable_retry}
      homeHref="/transactions"
      homeLabel="Riwayat Transaksi"
    />
  );
}
